import * as yup from 'yup'

export const ResetPasswordValidationSchema = yup.object().shape({
  password: yup.string().min(6,"1:Password must include at least 6 characters").matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{6,}$/, '3:Password must be atleast 6 characters and contain 1 upper case, 1 lower case, 1 number, and 1 special character').required("1:Password is required"),
  confirmPassword:yup.string().oneOf([yup.ref("password"),null],"2:Password and Confirm Password must match").required("2:Confirm Password is required")
});